import React, { Component } from 'react';
import userAvatar from '../images/defaultUserAvatar.jpg';
import memberAvatar from '../images/defaultMemberAvatarAlternate.jpg';

class Avatar extends Component {
    render() {
        let { image } = this.props;
        if (this.props.rank) {
            if (!image) {
                image = memberAvatar;
            }
            let styleColor = this.props.rank.color;
            let styleHeight = this.props.height;
            let styleWidth = this.props.height / 8;
            return (
                <div className="avatar">
                    <div className="avatar-rank" style={{
                        height: `${styleHeight}px`,
                        width: `${styleWidth}px`,
                        backgroundColor: `#${styleColor}`,
                        boxShadow: `0 0 ${styleHeight}px 1px #${styleColor}`,
                    }}></div>
                    <img alt="" src={image} width={this.props.width + "px"}
                         height={this.props.height + "px"}/>
                </div>
            );
        } else {
            if (!image) {
                image = userAvatar;
            }
            return (
                <div className="avatar">
                    <img alt="" src={image} width={this.props.width + "px"}
                         height={this.props.height + "px"}/>
                </div>
            )
        }
    }
}

export default Avatar;


// WEBPACK FOOTER //
// ./src/common/Avatar.js